export const createSelectCallback = (styles) => ({ isActive }) => isActive ?  styles.selected : "";

export default [
    {
        to: "/backend", layout: "/sidebar", children: [
            {to: "/backend/dashboard", text: "首页", component: "dashboard"},
            {to: "/backend/sieve/:category/batch", text: "检测", component: '/detection'},
            {to: "/backend/sieve/:category/single", text: "检测", component: '/record/single'},
            {to: "/backend/record/single/", text: "单条记录", component : "/record/single"},
            {to: "/backend/record/batch/:status", text: "多条记录", component : "/record/batch"},
            {to: "/backend/record/statistics", text: "统计报表", component : "/record/statistics"},
            {to: "/backend/record/api/statistics", text: "通道统计", component : "/channel/api_statistics"},
            {to: "/backend/tenant/list", text: "租户管理", component : "/user/list"},
            {to: "/backend/agent/list", text: "代理商管理", component : "/user/list"},
            {to: "/backend/customer/list", text: "客户管理", component : "/user/list"},
            {to: "/backend/customer/authentication", text: "客户认证", component : "/user/authentication"},
            {to: "/backend/customer/login/log", text: "登录日志", component : "/user/login"},
            {to: "/backend/channel/api", text: "接口管理", component : "/channel/api"},
            {to: "/backend/channel/store", text: "本地仓库", component : "/channel/store"},
            {to: "/backend/channel/dataset", text: "仓库数据", component : "/channel/dataset"},
            {to: "/backend/channel/upkeep", text: "仓库维护", component : "/channel/upkeep"},
            {to: "/backend/channel/search", text: "仓库查询", component : "/channel/search"},
            {to: "/backend/product/channel", text: "接口配置", hide: true, component : "/channel/config"},
            {to: "/backend/product/price", text: "价格配置", component : "/product/price"},
            {to: "/backend/product/list", text: "产品列表", component : "/product/list"},
            {to: "/backend/product/sort", text: "产品排序", component : "/product/sort"},
            {to: "/backend/customer/product/price", text: "产品配置", component : "/product/price"},
            {to: "/backend/channel/config", text: "通道配置", component : "/channel/config"},
            {to: "/backend/:role/recharge/:type", text: "充值管理", component : "/finance/recharge"},
            {to: "/backend/:role/consume", text: "消耗管理", component : "/finance/consume"},
            {to: "/backend/customer/give", text: "赠送管理", component : "/finance/give"},
            {to: "/backend/customer/remit", text: "客户汇款", component : "/finance/remit"},
            {to: "/backend/setting/account", text: "账号管理", component : "/setting/account"},
            {to: "/backend/setting/sms/template", text: "短信模板", component : "/setting/sms/template"},
            {to: "/backend/setting/sms/record", text: "短信记录", component : "/setting/sms/record"},
            {to: "/backend/setting/website", text: "网站设置", component : "/setting/website"},
            {to: "/backend/setting/pay", text: "支付设置", component : "/setting/pay"},
            {to: "/backend/setting/employee", text: "客服管理", component : "/setting/employee"},
            {to: "/backend/employee/list", text: "员工管理", component : "employee/list"},
            {to: "/backend/employee/achievement", text: "员工业绩", component : "employee/achievement"},
            {to: "/backend/setting/package", text: "充值套餐", component : "/setting/package"},
            {to: "/backend/website/tools", text: "网站工具", component : "/setting/tools"},
            {to: "/backend/website/news", text: "新闻动态", component : "/setting/news"},
            {to: "/backend/agent/return/list", text: "返佣记录", component: "/finance/return"}
        ]
    },
    {to: "/backend/login", component: "login", text: "系统登陆"}
]
